module.exports = __webpack_public_path__ + "Feed_logo.png?3d4f0b8947cfd35fdab002a7bc29ea7c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Feed_logo.png
// module id = 140
// module chunks = 0